import { jwtVerify, importSPKI } from 'jose'
import { UserRole } from '@/utils/constants'

const ROLES_TOKEN_PUBLIC_KEY = import.meta.env.VITE_ROLES_TOKEN_PUBLIC_KEY

let cachedKey: CryptoKey | null = null

async function getPublicKey(): Promise<CryptoKey> {
  if (!cachedKey) {
    cachedKey = await importSPKI(ROLES_TOKEN_PUBLIC_KEY, 'ES256')
  }
  return cachedKey
}

/**
 * Verify the roles token and return the roles
 * @param rolesToken - The roles token to verify
 * @returns The roles
 */
export async function verifyRolesToken(rolesToken: string): Promise<UserRole[]> {
  try {
    const publicKey = await getPublicKey()
    const { payload } = await jwtVerify(rolesToken, publicKey)
    return (payload.roles as UserRole[]) ?? []
  } catch (error) {
    return []
  }
}
